export enum ClinicInvoiceTerm {
  NET_30 = 'net30',
  NET_45 = 'net45',
  NET_60 = 'net60',
  NET_90 = 'net90',
}
